import {setProgressBar} from './setProgressBar';
import {getRefDetails} from './getRefDetails';
import {setServiceContactInfoOsVariables} from './setServiceContactInfoOsVariables';
import {addressDetailsScreen} from './addressDetailsScreen';
export function leadSchedulerNextButton(currentElement:any){
    var pane:any = $(currentElement).closest('.tab-pane').attr('id');
    var nextPane:any;
    switch (pane) {
        case "calendar-screen" :
            //nextPane =  $('.wam-scheduler .tab-content .tab-pane.active').next().attr('id');
            $('.tab-pane.fieldset').removeClass('active');
            $('#schedulerWizard #contact-information-screen').addClass('active'); 
            setProgressBar("contact-information-screen");
            break;
        case "contact-information-screen" :
            //nextPane =  $('.wam-scheduler .tab-content .tab-pane.active').next().attr('id');
            setServiceContactInfoOsVariables();
            $('.tab-pane.fieldset').removeClass('active');
            $('#schedulerWizard #service-address-screen').addClass('active');
            setProgressBar("service-address-screen");
            break;
        case "service-address-screen" :
            addressDetailsScreen();
            $('.tab-pane.fieldset').removeClass('active');
            $('#schedulerWizard #service-details-screen').addClass('active'); 
            setProgressBar("service-details-screen");
            getRefDetails();
             break;
             default :
             break;
            
    }
}